<template>
    <div class="py-10">
        <div class="border-b border-b-gray-200"></div>
    </div>
</template>
